import { useState } from "react";
import { useSelector } from "react-redux";
import FullCalendarTimeslot from "../common/fullcalendarTimeslot";
import PopUpViewPrenotationByTimeslot from "../popUpViewPrenotationByTimeslot";
import _ from "lodash";
import moment from "moment";

const PrenotationListCalendar = () => {
  const [showPopUpViewPrenotationByTimeslot, setShowPopUpViewPrenotationByTimeslot] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [selectedTimeslot, setSelectedTimeslot] = useState("");
  const [selectedDay, setSelectedDay] = useState("");

  const { eventId } = useSelector((store: any) => store.login);
  const eventsSourceUrl = `t4event/api/v01/event/${eventId}/fullcalendar/attendances`;
  // timeslot category selected in filter box
  const { search } = useSelector((store: any) => store.prenotation);
  const categoryIds = search.timeslotCategory ? [search.timeslotCategory] : [];

  const ClickFullCalendar = (arg: any) => {
    setSelectedBookingId(arg.event.extendedProps.bookingId);
    setSelectedTimeslot(arg.event.extendedProps.timeslotId);
    setSelectedDay(moment(arg.event.start).format('YYYY-MM-DD'));

    setShowPopUpViewPrenotationByTimeslot(true)
  }

  return (
    <>
      <div className="SectionPrenotation">
        <FullCalendarTimeslot
          typeCalendar="attendancesList"
          eventClick={ClickFullCalendar}
          eventsSourceUrl={eventsSourceUrl}
          categoryIds={categoryIds}
          searchText={search.searchInput}
        />
      </div>

      {showPopUpViewPrenotationByTimeslot && <PopUpViewPrenotationByTimeslot
        selectedDay={selectedDay}
        selectedTimeslotId={selectedTimeslot}
        selectedBookingId={selectedBookingId}
        closePopUp={() => setShowPopUpViewPrenotationByTimeslot(false)}
      />}
    </>
  )
}

export default PrenotationListCalendar;